var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"heart",on:{"click":function($event){return _vm.likeEvent(_vm.event)}}},[_c('img',{attrs:{"src":_vm.likeImage(_vm.event)}})])}
var staticRenderFns = []

export { render, staticRenderFns }